import React from 'react';
import { Route, Switch } from 'react-router-dom';

import LongtailBookingsList from '~pages/longtail-bookings/list';
import LongtailBookingsDetail from '~pages/longtail-bookings/detail';
import LeadgenDetails from '~pages/longtail-bookings/detail/lead-gen-details';

export default function LongtailBookings() {
  return (
    <Switch>
      <Route path="/booking/list" component={LongtailBookingsList} />

      <Route
        path="/booking/:referenceId?/detail"
        render={props => <LongtailBookingsDetail {...props} />}
      />
      <Route
        path="/booking/:referenceId?/lead_details"
        render={props => <LeadgenDetails {...props} />}
      />
    </Switch>
  );
}
